import { Navigate } from "react-router-dom";
function RequireAuth({ children }) {
	const isAuthenticated = localStorage.getItem("token"); // or however you check

	if (!isAuthenticated) {
		return <Navigate to="/" />;
	}

	return children;
}
export default RequireAuth;
